export const routes = {
  editDepositLimit: '/account/deposit-limits',
} as const
